import { createBrowserRouter } from "react-router-dom";

import { routes } from "common/lib/constants";

export const router = createBrowserRouter(routes);
